export const RESEARCH_ASSISTANT_SENDER_ID = "research-assistant";

export const RESEARCH_ASSISTANT_SENDER_NAME = "Research Assistant";

export const RESEARCH_ASSISTANT_DISCLAIMER =
  "Please use your professional expertise when assessing research to ensure it meets your clients' needs.";
